export default "/images/vendor/flag-icon-css/flags/1x1/mm.svg?68092d4110fca98beb037f1a0eda9974";